import { render } from "./LorryServiceTable.vue?vue&type=template&id=a6f5506c"
import script from "./LorryServiceTable.vue?vue&type=script&lang=js"
export * from "./LorryServiceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__